
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/furniture-removal",
      function () {
        return require("private-next-pages/furniture-removal/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/furniture-removal"])
      });
    }
  